import $ from 'jquery';
import { LARGE, CROSS_BREAKPOINT } from './breakpoint-controller';

const SELECTOR = '.featured-resource-slider';
const MOBILE = 'mobile';
const DESKTOP = 'desktop';

let els = [];
let mode = MOBILE;

function onDocumentReady() {
	els = $(SELECTOR);

	if (els.length > 0) {
		els.each(initializeElement);
		$(document).on(CROSS_BREAKPOINT, onCrossBreakpoint);
	}
}

function setMode(_mode) {
	if (mode === _mode) {
		return;
	}

	els.find('.icon, .feature-card').removeAttr('style');
	mode = _mode;
}

function onCrossBreakpoint(e, breakpoint) {
	if (breakpoint >= LARGE) {
		setMode(DESKTOP);
	} else {
		setMode(MOBILE);
	}
}

function initializeElement(i, el) {
	const $el = $(el);

	if ($el.find('.featured-resource').length < 2) {
		return;
	}

	$el
	.on('beforeChange', onBeforeChangeSlide)
	.on('afterChange', onAfterChangeSlide)
	.slick({
		autoplay: true,
		autoplaySpeed: 8000,
		fade: true,
		responsive: [
			{
				breakpoint: LARGE,
				settings: {
					fade: false
				}
			}
		]
	});
}

function onBeforeChangeSlide(e, slick, currentSlide, nextSlide) {
	if (window.innerWidth < LARGE) {
		return;
	}

	const $nextSlide = slick.$slides.eq(nextSlide);
	const card = $nextSlide.find('.feature-card');
	const icon = $nextSlide.find('.icon');

	card.css({
		opacity: 0,
		transform: 'translateX(200px)',
	});

	icon.css({
		opacity: 0,
		transform: 'translateY(100px)',
	});
}

function onAfterChangeSlide(e, slick, currentSlide) {
	if (window.innerWidth < LARGE) {
		return;
	}

	const $currentSlide = slick.$slides.eq(currentSlide);
	const card = $currentSlide.find('.feature-card');
	const icon = $currentSlide.find('.icon');

	icon.css({ transform: 'translateY(0)' }).animate({
		opacity: 1,
	});

	card.delay(300).css({ transform: 'translateX(0)' }).animate({
		opacity: 1,
	});
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
